"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AVATAR_CONFIG = exports.AVATAR_OPTIONS = void 0;
var rangeArray = function (n) { return Array.from(Array(n).keys()).map(function (i) { return i + 1; }); };
var rangeArrayString = function (n) {
    return rangeArray(n).map(function (i) { return (i < 10 ? "0".concat(i) : "".concat(i)); });
};
var rangeArrayVariant = function (n) {
    return rangeArrayString(n).map(function (i) { return "variant".concat(i); });
};
exports.AVATAR_OPTIONS = {
    beard: __spreadArray([null], __read(rangeArrayVariant(12)), false),
    body: rangeArrayVariant(25),
    bodyIcon: [null, "electric", "galaxy", "saturn"],
    brows: rangeArrayVariant(13),
    eyes: rangeArrayVariant(5),
    gesture: [
        null,
        "hand",
        "handPhone",
        "ok",
        "okLongArm",
        "point",
        "pointLongArm",
        "waveLongArm",
        "waveLongArms",
        "waveOkLongArms",
        "wavePointLongArms",
    ],
    glasses: __spreadArray([null], __read(rangeArrayVariant(11)), false),
    hair: __spreadArray(["hat", "bald"], __read(rangeArrayVariant(63)), false),
    lips: rangeArrayVariant(30),
    nose: rangeArrayVariant(20),
    backgroundColor: [null, "b6e3f4", "c0aede", "d1d4f9", "ffd5dc", "ffdfbf"],
};
exports.DEFAULT_AVATAR_CONFIG = {
    beard: null,
    body: exports.AVATAR_OPTIONS.body[0],
    bodyIcon: null,
    brows: exports.AVATAR_OPTIONS.brows[0],
    eyes: exports.AVATAR_OPTIONS.eyes[0],
    gesture: null,
    glasses: null,
    hair: exports.AVATAR_OPTIONS.hair[0],
    lips: exports.AVATAR_OPTIONS.lips[0],
    nose: exports.AVATAR_OPTIONS.nose[0],
    backgroundColor: exports.AVATAR_OPTIONS.backgroundColor[1],
};
